import http from '../../plugins/axios';

export default {
    getPurchaseList(data) {
        return http.get({
            url: '/admin/purchase/list',
            data
        })
    },

    getPurchaseOrder(data) {
        return http.get({
            url: `/admin/purchase/detail`,
            data
        });
    },

    purchaseAddWater(data) {
        return http.post({
            url: `/admin/purchase/addWater`,
            data,
            dataType: 'form'
        });
    },

    puchaseChecking(data) {
        return http.post({
            url: `/admin/purchase/puchaseChecking`,
            data,
            dataType: 'form'
        });
    },

    calculatePurchase(data) {
        return http.post({
            url: `/admin/purchase/calculatePurchase`,
            data,
            dataType: 'form'
        });
    },

    transPurchase(data) {
        return http.post({
            url: `/admin/purchase/transPurchase`,
            data,
            dataType: 'form'
        });
    }
}
